import titleCase from "./titleCase";

export default function normalizeDistrictName(s) {
  if (!s) return "";
  const x = String(s).trim().toLowerCase();
  const map = { sangali: "Sangli", sangli: "Sangli" };
  return map[x] || titleCase(String(s).trim());
}